import React from "react";

import fileIcon from "../../../images/table-image/icon/attachment.svg";
import bookIcon from "../../../images/table-image/icon/book.svg";
import calendarIcon from "../../../images/table-image/icon/calendar-icon.svg";
import contactIcon from "../../../images/table-image/icon/contact.svg";
import textIcon from "../../../images/table-image/icon/text-icon.svg";

type Props = {
  fieldName?: string;
  title?: string;
  width?: number;
};

function AttachedDocumentHeader({ title, fieldName, width }: Props) {
  const style = { width };

  const iconMap = {
    filename: fileIcon,
    file_upload_download: fileIcon,
    upload_date: calendarIcon,
    owner: contactIcon,
    description: textIcon,
    file_name: bookIcon,
    document_type: bookIcon,
  };

  // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
  const icon = iconMap[fieldName];

  return (
    <li style={style}>
      {icon && <img src={icon} alt="icon" />}
      {title}
    </li>
  );
}

AttachedDocumentHeader.defaultProps = {
  title: "",
  fieldName: "",
  width: 200,
};

export default AttachedDocumentHeader;
